<fcom-modal
  [open]="true"
  [fitToContent]="true"
  [fullHeight]="true"
  [buttons]="ModalButtons.CUSTOM"
  [overlayClickable]="true"
  [forceRemainOpen]="true"
>
  <div class="flex flex--center">
    <h3 class="ps-large bold-type nordic-blue-900-text flex-1">
      {{ 'MMB.view.changeFlightsModal.matrixTitle' | finLocalization }}
    </h3>

    <div class="inline-block ps-large-r ps-large flex-0">
      <button
        (click)="closeModal()"
        class="btn--no-outline focus-inset pr-xsmall-y"
        [attr.title]="'actions.close' | finLocalization"
        [attr.aria-label]="'actions.close' | finLocalization"
      >
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CLOSE_DELETE"></fcom-icon>
      </button>
    </div>
  </div>

  <fin-price-matrix
    [order]="booking$ | async"
    [calendarList]="calendarChangeList$ | async"
    (selectedDates)="datesSelected($event)"
  ></fin-price-matrix>
  <div buttons>
    <fcom-button
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      class="nordic-blue-900-text info-link font-body-1 medium-type dn-mobile"
      [text]="'MMB.view.changeFlightsModal.changeDates' | finLocalization"
      (clickBtn)="selectDatesStep()"
      [aria]="{ label: 'MMB.view.changeFlightsModal.selectDateRange' | finLocalization, role: 'button' }"
    >
    </fcom-button>
    <fcom-button
      data-testid="select-matrix-continue-button"
      [disabled]="(newDates$ | async) === null"
      [text]="'actions.continue' | finLocalization"
      (clickBtn)="redirectToChangeFlow()"
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      class="mr-small-l"
    ></fcom-button>
  </div>
</fcom-modal>
